import { CustomError } from '@core/utils';

//* return_code가 붙은 실패는 서버의 판정이라 재시도해도 결과가 같고 같은 키 관찰자가 모두 늦어진다
export const retryUnlessReturnCode = (failureCount: number, error: unknown) =>
  !(error instanceof CustomError && error.return_code !== undefined) &&
  failureCount < 3;
